// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { IsNotEmpty, IsPositive, IsCurrency } from "class-validator";
// App
import { MoneyGifterDTO } from "Globals/Models/DTO/MoneyGifterDTO";

export class MoneyGifterModel extends ModelBase<MoneyGifterModel, MoneyGifterDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public incomeDetailId: string | null = null;

    @IsNotEmpty({ message: "Name of person gifting money is required" })
    @MobX.observable
    public name: string | null = null;

    @IsNotEmpty({ message: "Total gifted money is required" })
    @MobX.observable
    public amount: number | null = 0;

    @MobX.observable public createdDate: Date | null = null;

    @MobX.observable public sameForApplicantTwo: boolean = false;

    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: MoneyGifterDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.incomeDetailId = model.incomeDetailId;
            this.name = model.name;
            this.amount = model.amount;
            this.createdDate = model.createdDate;
            this.sameForApplicantTwo = model.sameForApplicantTwo;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): MoneyGifterDTO => {
        let model: MoneyGifterDTO = {
            id: this.id,
            incomeDetailId: this.incomeDetailId,
            name: this.name,
            amount: this.amount,
            createdDate: this.createdDate,
            sameForApplicantTwo: this.sameForApplicantTwo,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = null;
        this.incomeDetailId = null;
        this.name = "";
        this.amount = 0;
        this.createdDate = null;
        this.sameForApplicantTwo = false;
        this.isDeleted = false;
    };
}
